import { render, staticRenderFns } from "./TheNewsItem.vue?vue&type=template&id=28c6facc"
import script from "./TheNewsItem.vue?vue&type=script&lang=js"
export * from "./TheNewsItem.vue?vue&type=script&lang=js"
import style0 from "./TheNewsItem.vue?vue&type=style&index=0&id=28c6facc&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports